/**
 * Determina se deve renderizar um componente com base na rota atual.
 *
 * @param {Array<string>} excludedRoutes - Um array de strings que representa as rotas nas quais o componente não deve ser renderizado.
 * @returns {boolean} - Retorna true se o componente deve ser renderizado, false caso contrário.
 */
export const shouldRenderComponent = (excludedRoutes: any) => {
    const currentPath = window.location.pathname;
    return !excludedRoutes.includes(currentPath);
  };